<template>
  <div class="flex justify-end mb-[1px]">
    <ReadIcon v-if="compData.read" />
    <SentIcon v-else />
  </div>
</template>
<script setup>
import ReadIcon from "@/assets/customIcons/Read.vue";
import SentIcon from "@/assets/customIcons/Sent.vue";
const props = defineProps({
  compData: {
    type: Object,
    default: {},
  },
});
</script>
